import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { switchMap } from 'rxjs';
import { StripeService } from 'ngx-stripe';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  creator_code = '';
  promotion_code = '';
  percentOff = 0;
  private http = inject(HttpClient);
  private stripeService = inject(StripeService);

  setCreatorCode(creator_code: string, promotion_code: string, percentOff: number) {
    this.creator_code = creator_code;
    this.promotion_code = promotion_code;
    this.percentOff = percentOff;
  }

  getPercentOff() {
    return this.percentOff;
  }

  checkout(itemId: string, _creatorCode = '', _promotion_code = '') {
    let params = new HttpParams().set('itemId', itemId);
    if (this.creator_code && this.promotion_code) {
      params = params.set('creator_code', this.creator_code).set('promotion_code', this.promotion_code);
    }
    return this.http.get<any>(environment.apiURL + '/services/payments/create-checkout-session/', { params })
      .pipe(
        switchMap(async (session: any) => {
          const stripe = await this.stripeService.getInstance();
          return (stripe as any)?.redirectToCheckout({ sessionId: session.sessionId });
        })
      );
  }
}
